import { Box, Button } from "@chakra-ui/react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import http from "../../../core/http";

const PaymentMethodForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: "https://redwing.app/billing",
      },
      redirect: "if_required",
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
      setLoading(false);
    } else {
      const response = await http.post("/v1/subscriptions/payment", {
        paymentMethod: result.setupIntent.payment_method,
      });

      if (response.error) {
        alert(`Failed ${response.error.message}`);
        setLoading(false);
      }

      // Success code here
      setLoading(false);
      onSuccess();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box bg="white" borderRadius="lg" pb="6">
        <PaymentElement />
        <Button
          type="submit"
          mt="3"
          disabled={!stripe || loading}
          colorScheme="red"
          color="white"
          tabIndex={5}
        >
          Update payment method
        </Button>
      </Box>
    </form>
  );
};

export default PaymentMethodForm;
